module.exports = __webpack_public_path__ + "img/test.adba0206.jpg";